import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Portofolio.css';

export default function ConectividadLegacy() {
    return (
        <div className="portfolio-container">
            <Helmet>
                <title>Conectividad Legacy (SAP/ERP) | Navi</title>
                <meta name="description"
                      content="Automatización en sistemas cerrados sin API utilizando Playwright. Extraemos e introducimos datos en plataformas antiguas como SAP para la gestión de envíos."/>
            </Helmet>

            {/* --- ENCABEZADO DEL PORTFOLIO --- */}
            <header className="portfolio-header">
                <span className="portfolio-category">SECTOR: LOGÍSTICA Y GESTIÓN</span>
                <h1 className="portfolio-title">Conectividad Legacy (SAP/ERP)</h1>
                <h2 className="portfolio-subtitle">
                    Automatizamos lo inautomatizable. Conectamos tus agentes de IA con sistemas cerrados, antiguos o sin
                    API, dándoles nueva vida.
                </h2>
            </header>

            <div className="portfolio-hero-image">
                <img src="/imagenes_portofolio/Portofolio4_asset1.png" alt="Orquestamiento multi-agente"/>
            </div>
            {/* --- CONTENIDO --- */}
            <div className="portfolio-content">
                <p>
                    El mayor obstáculo para la transformación digital en grandes empresas de logística no suele ser la
                    falta de voluntad, sino la dependencia de sistemas heredados (Legacy). Plataformas robustas pero
                    cerradas, como versiones antiguas de SAP o ERPs a medida, que carecen de APIs modernas para
                    integrarse con nuevas tecnologías.
                </p>

                <h3>El Enfoque: Automatización en Sistemas Cerrados</h3>
                <p>
                    Cuando no hay una "puerta trasera" (API) para que los sistemas hablen entre sí, nosotros construimos
                    una solución que entra por la "puerta principal". Nos enfocamos en la <strong>automatización en
                    sistemas cerrados sin API</strong> simulando la interacción humana a velocidades sobrehumanas.
                </p>

                <h3>La Tecnología y el Stack</h3>
                <p>
                    Para lograr esta proeza técnica de manera fiable y escalable, utilizamos herramientas de
                    automatización web y de escritorio de última generación:
                </p>
                <ul>
                    <li><strong>Playwright:</strong> Nuestro motor principal para la automatización avanzada y la
                        ingesta dinámica de datos directamente desde la interfaz de usuario (RPA moderno).
                    </li>
                    <li><strong>FastAPI:</strong> Para crear una capa de API moderna sobre tu sistema antiguo,
                        permitiendo que la IA interactúe con él de forma estructurada.
                    </li>
                    <li><strong>PostgreSQL, ChromaDB & Qdrant:</strong> Para almacenar, estructurar y dar contexto
                        vectorial a los datos extraídos del sistema legacy.
                    </li>
                </ul>

                <h3>El Diferencial: Bidireccionalidad Real</h3>
                <p>
                    Muchos sistemas de scraping solo leen datos. Nuestra solución va un paso más allá.
                </p>
                <blockquote className="portfolio-quote">
                    "Tenemos la capacidad no solo de extraer información, sino de introducir datos de forma autónoma y
                    segura en plataformas antiguas o cerradas."
                </blockquote>

                <h3>El Impacto</h3>
                <p>
                    Para el sector de la logística y la gestión, esto supone un antes y un después. Logramos la <strong>automatización
                    total de consultas a proveedores</strong> y la actualización de la <strong>gestión de envíos en
                    tiempo real</strong>, eliminando por completo el trabajo manual de "copiar y pegar" entre diferentes
                    pantallas.
                </p>

                {/* --- GIF DEMOSTRATIVO --- */}
                <figure className="portfolio-image-wrapper">
                    {/* Reemplaza esta ruta con la de tu GIF real */}
                    <img src="/imagenes_portofolio/Portofolio4_asset2.gif"
                         alt="Automatización Playwright interactuando con un ERP antiguo"/>
                    <figcaption>Extracción e inserción automatizada de datos en interfaz sin API.</figcaption>
                </figure>

                {/* --- CAJA DE LLAMADA A LA ACCIÓN (CTA) --- */}
                <div className="portfolio-cta-box">
                    <h3>¿Tu ERP antiguo frena la innovación de tu empresa?</h3>
                    <p>Descubre cómo podemos conectar la Inteligencia Artificial a tus sistemas actuales sin necesidad
                        de migraciones costosas ni desarrollo de APIs.</p>

                    <button
                        className="cta-button"
                        onClick={() => window.open(
                            'https://wa.me/34624118531?text=%C2%A1Hola!%20Me%20interesa%20conocer%20m%C3%A1s%20sobre%20la%20Conectividad%20Legacy%20(SAP/ERP).',
                            '_blank'
                        )}
                    >
                        Modernizar mi sistema hoy
                    </button>
                </div>
            </div>
        </div>
    );
}